const initialState = {
    lowerFunnelSection:{sections:undefined},
   activeSection:"about-business", 
   completedSection:[]
  
  }
  
  const reducer = (state = {...initialState}, action) => {
    switch (action.type) {
      case 'LOWER_FUNNEL_LOADER': return {
        ...state,lowerFunnelLoader:action.data
      }
      case 'LOWER_FUNNEL_SECTIONS': 
      return {
        ...state,lowerFunnelSection:action.data
      }
      case 'SET_ACTIVE_ID':
        return {
          ...state,
          activeSection: action.payload
        };
      case 'SET_COMPLETED_SECTION':
        return {
          ...state,
          completedSection: action.payload
        };
      case 'SET_EDIT_SECTION':
        return {
          ...state,
          editSection: action.payload
        };
      case 'RESET_NEW_CHECKOUT_TO_INITIAL_STATE':
        return {
          ...initialState
        }
      default:
        return state;
    }
  };
  export default reducer;